<template>
  <div class="c-flex-c1">
    <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->
    <div class="toolbar-pagetop">
      <!-- PC TOOLBAR -->
      <div v-if="!$vuetify.breakpoint.xs" class="pl-4 pr-4 pt-4">

        <v-layout align-center>
          <div class="display-1">
            Customers
          </div>
        </v-layout>

        <!-- pagination toolbar -->
       

      </div>

      <!-- MOBILE toolbar -->
      <div v-if="$vuetify.breakpoint.xs">
        <v-layout align-center>
          <v-btn icon @click="drawer = !drawer">
            <v-icon>menu</v-icon>
          </v-btn>
          <v-flex class="text-ellipsed text-sans font-weight-bold">
            Customers
          </v-flex>
        </v-layout>
      </div>

    </div>
    <!-- end toolbar container, to prevent parent flexer shrinking children linke hlines -->


    <!-- NEW MAIN CONTENT -->
    <v-card class="ma-2">
      <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->
      <div class="toolbar-pagetop">
        <!-- PC TOOLBAR -->
        <div v-if="!$vuetify.breakpoint.xs">

          <!-- pagination toolbar -->
          <v-row class="align-center pl-4 pr-2 pt-2 pb-2">

            <transition
            name="slide-x-reverse-transition"
            mode="out-in">

              <!-- ITEMS -->
              <div 
              v-if="selectedCount === 0"
              key="1"
              class="c-flex-r align-center subheading">

                <!-- select menu -->
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon>mdi-check-box-multiple-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                    @click="selectAll">
                      <v-list-item-title>Select all</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                    @click="selectPage">
                      <v-list-item-title>Select page</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                    @click="selectNone">
                      <v-list-item-title>Select none</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-btn
                text
                outlined
                class="mr-2"
                @click="newCustomer">
                  <v-icon>add</v-icon>
                  <div class="ml-1 text--text">
                    New customer
                  </div>
                </v-btn>

                <v-menu offset-y :close-on-content-click="false" min-width="280px">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      text
                      outlined
                      v-on="on"
                    >
                      <v-icon>mdi-filter</v-icon>
                      <div class="ml-1 text--text">
                        Filter
                      </div>
                      <span v-if="activeFilterCount > 0">
                        &nbsp;|&nbsp;
                        <span class="color1--text">
                          {{ activeFilterCount }}
                        </span>
                      </span>
                    </v-btn>
                  </template>
                  <v-card class="">
                    <v-layout class="pl-2 pt-2 pb-2 font-weight-bold unselectable cursor-pointer" @click="filters.active.customer = !filters.active.customer">
                      <v-icon small v-if="filters.active.customer" color="color1">
                        mdi-checkbox-marked-outline
                      </v-icon>
                      <v-icon small v-else>
                        mdi-checkbox-blank-outline
                      </v-icon>
                      &nbsp;
                      Customer:
                    </v-layout>
                    <div class="c-hr"></div>
                    <v-expand-transition>
                      <div v-show="filters.active.customer">
                        <div style="background: #f7fafc;" class="pt-1 pb-1">
                          <v-layout v-for="customer of customerIDS" :key="customer.id" align-center class="pl-2">
                            {{ customer.name }}
                            <v-spacer></v-spacer>
                            <v-btn icon @click="removeCustomer(customer.id)">
                              <v-icon small>mdi-close</v-icon>
                            </v-btn>
                          </v-layout>
                          <c-select-customer :selectedID.sync="customerID" @change="changeItem" class="ma-2 crx-box-input caption"></c-select-customer>
                        </div>
                      </div>
                    </v-expand-transition>

                    <div class="c-hr"></div>
                    <v-layout class="pl-2 pt-2 pb-2 font-weight-bold unselectable cursor-pointer" @click="filters.active.date = !filters.active.date">
                      <v-icon small v-if="filters.active.date" color="color1">
                        mdi-checkbox-marked-outline
                      </v-icon>
                      <v-icon small v-else>
                        mdi-checkbox-blank-outline
                      </v-icon>
                      &nbsp;
                      Date:
                    </v-layout>
                    <div class="c-hr"></div>
                    <v-expand-transition>
                      <div v-show="filters.active.date">
                        <div style="background: #f7fafc;" class="pt-1 pb-1">
                          <v-select
                            v-model="filters.date.mainSelect"
                            class="ma-2 input-slot-thin-border caption"
                            :items="dateFilters"
                            dense
                            hide-details
                            solo
                          ></v-select>
                          <!-- DATE OPTIONS -->
                          <div v-if="filters.date.mainSelect === 'is in the last'">
                            <v-layout class="pl-2 pr-2" style="width: 12em;">
                                <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                                &nbsp;
                                <c-input :value.sync="filters.date.isInTheLast_input" class="crx-box-input mr-2" style="flex: 0 0 3em;"></c-input>
            
                                <v-select
                                  v-model="filters.date.isInTheLast_select"
                                  class="input-slot-thin-border caption"
                                  style="flex: 0 0 5em;"
                                  :items="['days', 'months']"
                                  dense
                                  hide-details
                                  solo
                                ></v-select>
                            
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is equal to'">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is between'">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="ma-2 crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                              and
                              <c-date :date.sync="filters.date.date2" class="ma-2 crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is after'" class="">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is on or after'" class="">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is before'" class="">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is on or before'" class="">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          
                        </div>
                      </div>
                    </v-expand-transition>
                  </v-card>
                </v-menu>

              </div>

              <!-- selected count -->
              <div v-if="selectedCount > 0"
              key="2"
              class="c-flex-r align-center subheading">
                <v-btn
                icon
                class=""
                @click="selected = {}">
                  <v-icon color="color1">close</v-icon>
                </v-btn>
                <div class="text-sans font-weight-bold">
                  <span>&nbsp;{{ selectedCount }}</span>
                  selected 
                </div>
                <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
                <span class="icon--text ml-2">|</span>
                <v-btn 
                icon
                @click="onDelete">
                  <v-icon>delete_outline</v-icon>
                </v-btn>
                <!-- select menu -->
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon>mdi-check-box-multiple-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                    @click="selectAll">
                      <v-list-item-title>Select all</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                    @click="selectPage">
                      <v-list-item-title>Select page</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                    @click="selectNone">
                      <v-list-item-title>Select none</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>

            </transition>

            <v-spacer></v-spacer>

            <div>
              <transition
              name="fade-transition"
              mode="out-in">
                <v-layout v-if="isLoading" key="L1" class="mr-2" align-baseline>
                  <span class="grey--text caption">LOADING...</span>&nbsp;
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-layout>
                <div v-else key="L2"></div>
              </transition>
            </div>

          </v-row>

        </div>

        <!-- MOBILE toolbar -->
        <div v-if="$vuetify.breakpoint.xs">
        </div>
      </div>
      <!-- end toolbar container, to prevent parent flexer shrinking children linke hlines -->

      <!-- MAIN CONTENT -->
        
        <template>
          <!-- TOOLBAR -->

          <table class="final-table full-width lines-b no-padding">
            <colgroup ref="colgroup1">
              <col width="200px">
              <col width="200px">
              <col width="200px">
            </colgroup>

            <tr class="unselectable">
              <c-table-header
              title="Name"
              code="name"
              class="sticky"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
            
              <c-table-header
              title="Email"
              code="email"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>

              <c-table-header
              title="ID"
              code="id"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>

            </tr>

            <tr style="">
              <td style="padding: 8px 12px 8px 16px;">
                <v-text-field
                v-model="filters.search.name"
                placeholder="Search..."
                hide-details
                class="crx-box-input"
                clearable
                color="color1"
                solo></v-text-field>
              </td>
              <td></td>
              <td></td>
            </tr>

          </table>

   

          <!-- TOOLBAR -->
          <table class="final-table lines-b pointer hover full-width">
            <colgroup ref="colgroup2">
              <col width="200px">
              <col width="200px">
              <col width="200px">
            </colgroup>

            <list-row
            v-for="item in items" 
            :key="item.id"
            vmode="table"
            :item="item"
            :itemsMeta="itemsMeta"
            :selected="selected"
            :searchTextID="filters.search.id"
            @checkRow="checkRow(item)"
            @click.native="clickRow(item)"
            ></list-row>

          </table>

          <!-- no item card (place this outside the scrolling div) -->
          <div v-if="(filters.search.id || '').length > 0 && count.length === 0"
          class="ma-2 pa-2">
            No items match your search "<span class="font-weight-bold">{{ filters.search.id }}</span>"
          </div>
          <!-- no item card -->
        </template>
        <!-- No sales -->
        <v-card v-if="items.length === 0" class="pa-2 ma-4 subheading elevation-0" style="border-bottom: 1px solid var(--v-hline-base);border-top: 1px solid var(--v-hline-base);">
          <v-layout v-if="searchIsActive" align-center>
            <img src="@/assets/img/illustrations/purse.png" alt="cardboard box" width="36px">
            <div class="ml-2 mr-2">
              <v-layout align-center>
                <span>
                  No items match your search
                </span>
                <v-icon large color="red accent-4">search</v-icon>
              </v-layout>

              <div class="caption text--text text--darken-1">
                clear search
              </div>
            </div>
          </v-layout>
          <v-layout v-else-if="activeFilterCount > 0" align-center>
            <img src="@/assets/img/illustrations/purse.png" alt="cardboard box" width="36px">
            <div class="ml-2 mr-2">
              <v-layout align-center>
                <span>
                  No items match your filters
                </span>
                <v-icon large color="red accent-4">search</v-icon>
              </v-layout>

              <div class="caption text--text text--darken-1">
                clear filters
              </div>
            </div>
          </v-layout>
          <v-layout v-else align-center>
            <img src="@/assets/img/illustrations/purse.png" alt="cardboard box" width="36px">
            <div class="ml-2 mr-2">
              <v-layout align-center>
                <span>
                  0 customer definitions.
                </span>
              </v-layout>

              <div class="caption text--text text--darken-1">
                Click 'New customer' to create your first customer.
              </div>
            </div>
          </v-layout>
        </v-card>

        
        <!-- PAGINATION -->
        <c-pagination
        :page="page"
        :pagination="pagination"
        :filters="filters"
        @updatePageNumber="updatePageNumber"
        @goToFirstPage="goToFirstPage"
        @goToPreviousPage="goToPreviousPage"
        @goToNextPage="goToNextPage"
        @goToLastPage="goToLastPage"
        ></c-pagination>
        <!-- PAGINATION -->

      <!-- END MAIN CONTENT -->

    </v-card>
    <!-- NEW MAIN CONTENT -->


    <!-- MAIN CONTENT -->
    <template v-if="false">
      <div style="overflow: auto;">

        <div style="overflow: auto; flex: 1; position: relative;">

          <!-- TOOLBAR -->
          <div style="position: sticky; top: 0; z-index: 3; background: white;">
            <table class="final-table full-width">
              <colgroup ref="colgroup1">
                <col width="200px">
                <col width="200px">
                <col width="200px">
              </colgroup>

              <tr class="unselectable">
                <th class="sticky zoo">
                  <span @click="clickSortHeader(0)" class="sort-button" style="padding-left: 16px;">
                    Name
                    <v-icon 
                    small
                    color="color1"
                    :class="['sort-arrow', {'rotate': sortIndex === 0 && sortAscending}, {'visible': sortIndex === 0 }]">
                      arrow_downward
                    </v-icon>
                  </span>
                  <div class="handle" @mousedown="startColDrag(0, $event)"></div>
                </th>
                <th class="zoo">
                  <span @click="clickSortHeader(1)" class="sort-button">
                    Email
                    <v-icon 
                    small
                    color="color1"
                    :class="['sort-arrow', {'rotate': sortIndex === 1 && sortAscending}, {'visible': sortIndex === 1 }]">
                      arrow_downward
                    </v-icon>
                  </span>
                  <div class="handle" @mousedown="startColDrag(1, $event)"></div>
                </th>
                <th>
                  <span @click="clickSortHeader(2)" class="sort-button">
                    Meta
                    <v-icon 
                    small
                    color="color1"
                    :class="['sort-arrow', {'rotate': sortIndex === 2 && sortAscending}, {'visible': sortIndex === 2 }]">
                      arrow_downward
                    </v-icon>
                  </span>
                  <div class="handle" @mousedown="startColDrag(2, $event)"></div>
                </th>
              </tr>

              <tr>
                <td class="sticky">
                  <v-text-field
                  v-model="searchText"
                  placeholder="Search"
                  hide-details
                  clearable
                  solo></v-text-field>
                </td>
                <td></td>
                <td></td>
              </tr>

            </table>
          </div>
          <!-- TOOLBAR -->
          <table class="final-table pointer hover full-width">
            <colgroup ref="colgroup2">
              <col width="200px">
              <col width="200px">
              <col width="200px">
            </colgroup>

            <customer-row
            v-for="item in paginatedArray" 
            :key="item.tempID"
            vmode="table"
            :item="item"
            :selected="selected"
            :sortIndex="sortIndex"
            :searchText="searchText"
            @checkRow="checkRow(item)"
            @click.native="clickRow(item)"
            ></customer-row>

          </table>

          <div class="text-xs-center" style="position: sticky; left: 0;">
            <v-pagination
            v-if="paginationLength > 1"
            v-model="page"
            :length="paginationLength"
            circle>

            </v-pagination>
          </div>

          <!-- no item card (place this outside the scrolling div) -->
          <div v-if="(searchText || '').length > 0 && searchMatches.length === 0"
          class="ma-2 pa-2">
            No items match your search "<span class="font-weight-bold">{{ searchText }}</span>"
          </div>
          <div v-else-if="items.length < 1"
          class="ma-2 pa-2">
            No items
          </div>
          <!-- no item card -->

        </div>

      </div>
    </template>
    <!-- END MAIN CONTENT -->

  </div>
</template>

<script>
import ServerListController from '@/mixins/ServerListController'
import ServerListRouteBindings from '@/mixins/ServerListRouteBindings'
import ListRow from './components/ListRow'

export default {
  name: 'CustomerList',
  mixins: [ServerListController, ServerListRouteBindings],
  components: {
    ListRow
  },
  data () {
    return {
      isLoading: false,
      page: 0,
      filters: {
        rowsPerPage: 10,
        sortCol: 'name',
        sortAscending: true,
        customerIDS: [],
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
          name: ''
        },
        active: {
          customer: false,
          date: false
        }
      },
      customerID: null,
      customerIDS: [],
      dateFilters: ['is in the last', 'is equal to', 'is between', 'is after', 'is on or after', 'is before', 'is on or before'],
      itemsMeta: {
        newID: null // this will be set to the newst created row
      }
    }
  },
  computed: {
    itemsSource () {
      return Object.values(this.$store.state.db.customers.customers)
    }
  },
  watch: {
    itemsSource: {
      immediate: true,
      handler (nv) {
        this.items = nv
      }
    }
  },
  methods: {
    changeItem (newItem) {
      var match = this.customerIDS.find(item => item.id === newItem.id)
      if (!match) {
        this.customerIDS.push(newItem)
      }
      this.$nextTick(() => {
        this.customerID = null
      })
    },
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        this.$router.push('/customer/' + item.id)
      }
    },
    newCustomer () {
      this.$router.push('/customers/new')
    },
    onDelete () {
      var idArray = this.getSelectedRows()
      var title = 'Delete ' + idArray.length + ' customer' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          this.$axios.post('customers/delete', idArray,
            {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(response => {
              this.selected = {} // This MUST be done after a successfull delete
              this.loadAPI()
            })
            .catch(error => this.$root.$errorSnackbar(error))
        }
      })
    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        this.$axios.get(`/customers?filters=${encodedFilters}&page=${this.page}`)
          .then(response => {
            var hrend = response.data.execution_time
            // console.log(hrend)
            // console.info('Execution time (hr): %ds %dms', hrend[0], hrend[1] / 1000000)
            var rows = response.data.rows
            this.pagination.rowCount = response.data.count
            this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
            if (this.items.length > rows.length) {
              this.currentIndex = 0
            }
            this.items = rows
          })
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            this.isLoading = false
          })
      })
    }, 150, {leading: true})
  },
  created () {
    this.loadAPI()
  },
  activated () {
    // this triggers when a keep alive component is returned to
    this.loadAPI()
  }
}
</script>

<style scoped lang="scss">
.hrow {
  border-bottom: 1px solid var(--v-hline-base);
  position: relative;
  overflow: hidden;
  & .header {
    cursor: pointer;
    min-height: 56px;
    display: flex;
    align-items: center;
  }
  & .cell {
    padding: 8px;
  }
}
.sort-arrow {
  opacity: 0;

  &.visible {
    opacity: 1;
  }
  &.rotate {
    transform: rotate( -180deg );
  }
}
</style>

